import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';

import type { AiSuggestionsPlugin } from '../aiSuggestionsPluginType';
import { updateSuggestions } from '../ui/utils/updateSuggestions';

import type { RefreshSuggestionsAction } from './types';

const POLL_INTERVAL_MS = 30_000;

export const refreshSuggestionsAction = (
	api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined,
	contentAri?: string,
): RefreshSuggestionsAction => {
	let pollHandle: ReturnType<typeof setInterval> | undefined;

	const snapshotIds = () =>
		api?.aiSuggestions?.sharedState.currentState()?.orderedSuggestionIds.join(',') ?? '';

	const stopPolling = () => {
		if (pollHandle !== undefined) {
			clearInterval(pollHandle);
			pollHandle = undefined;
		}
	};

	return (poll: boolean): boolean => {
		if (!api) {
			return false;
		}

		stopPolling();
		void updateSuggestions({ api, contentAri });

		if (poll) {
			pollHandle = setInterval(async () => {
				const before = snapshotIds();
				await updateSuggestions({ api, contentAri });
				if (snapshotIds() !== before) {
					stopPolling();
				}
			}, POLL_INTERVAL_MS);
		}

		return true;
	};
};
